export default __webpack_public_path__ + "media/zurb/img/playground/lord-kelvin-face-8a27576968b84176eefb7394b254450d.png";